export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://0dxnrp41n3.execute-api.us-west-2.amazonaws.com/prod"
  }
};
